import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import CheckboxField from '../components/CheckboxField';
import RadioField from '../components/RadioField';
import TextAreaField from '../components/TextAreaField';
import UploadField from '../components/UploadField';
import CustomDatePicker from '../components/CustomDatePicker';
import Modal from '../components/Modal';

import { HttpClient } from '../../services/http-client';
import { AppContext } from '../../App';

import { useForm, Controller, useFieldArray } from 'react-hook-form';

import { PDFExport, savePDF } from '@progress/kendo-react-pdf';

const Sidebar = ({ applicationId, activeSection, setActiveSection, areAllModulesRequired }) => {
    const location = useLocation();
    return (
      <div className="sidebar w-208 bg-ui h-full py-4 text-lg">
        <ul>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'personal' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=personal`} onClick={() => setActiveSection('personal')}>Personal Details</Link></li>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'work' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=work`} onClick={() => setActiveSection('work')}>Work Experience</Link></li>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'education' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=education`} onClick={() => setActiveSection('education')}>Education &amp; Professional Qualifications</Link></li>
            {!areAllModulesRequired && (
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'modules' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=modules`} onClick={() => setActiveSection('modules')}>Modules</Link></li>
            )}
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'entry-criteria' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=entry-criteria`} onClick={() => setActiveSection('entry-criteria')}>Entry Criteria</Link></li>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'invoices' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=invoices`} onClick={() => setActiveSection('invoices')}>Invoices</Link></li>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'export' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=export`} onClick={() => setActiveSection('export')}>Export</Link></li>
            <li><Link className={`py-2 px-4 hover:bg-uiactive cursor-pointer flex ${activeSection === 'status' ? 'bg-uiactive' : ''}`} to={`../application/edit/${applicationId}?section=status`} onClick={() => setActiveSection('status')}>Payment &amp; Status</Link></li>
        </ul>
      </div>
    );
};

const PersonalDetails = ({ applicant, formData, handleInputChange, register, errors, control, handleSubmit, onSubmit }) => {
    console.log(applicant)
    const [countryOptions, setCountryOptions] = useState([]);
    if (!countryOptions.find(c => c.countryId == 0)) {
        const newCountryOptions = [...formData.countries];
        newCountryOptions.unshift({ countryId: 0, countryDisplayName: "None" });
        setCountryOptions(newCountryOptions);
    }

    return (
        <div className='h-full text-sm p-6 w-full'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Personal Details
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                    About
                </h2>
                <InputField
                    label="Title"
                    name="title"
                    register={register}
                />
                <InputField 
                    label="First name"
                    name="firstName"
                    register={register}
                />
                <InputField 
                    label="Middle name"
                    name="middleName"
                    register={register}
                />
                <InputField 
                    label="Last name"
                    name="lastName"
                    register={register}
                />
                <InputField 
                    label="Certificate name"
                    name="certificateName"
                    register={register}
                />
                <InputField 
                    label="Email address"
                    name="email"
                    register={register}
                />
                <InputField 
                    label="Email to receive course notifications"
                    name="courseCorrespondenceEmail"
                    register={register}
                />
                <InputField 
                    label="Telephone"
                    name="phone"
                    register={register}
                />
                <InputField 
                    label="Mobile"
                    name="mobile"
                    register={register}
                />
                <SelectField
                    label="Gender"
                    name="genderId"
                    options={formData.genders}
                    valueField="itemId"
                    textField="description"
                    register={register}
                />
                <SelectField
                    label="Nationality"
                    name="nationalityId"
                    options={formData.countries}
                    valueField="countryId"
                    textField="countryDisplayName"
                    register={register}
                />
                <SelectField
                    label="Country of residence"
                    name="countryOfResidenceId"
                    options={formData.countries}
                    valueField="countryId"
                    textField="countryDisplayName"
                    register={register}
                />
                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                    Address
                </h2>
                <InputField 
                    label="Home Address 1"
                    name="homeAddress1"
                    register={register}
                />
                <InputField 
                    label="Home Address 2"
                    name="homeAddress2"
                    register={register}
                />
                <InputField 
                    label="City"
                    name="homeCity"
                    register={register}
                />
                <InputField 
                    label="State"
                    name="homeState"
                    register={register}
                />
                <InputField 
                    label="Postcode"
                    name="homePostcode"
                    register={register}
                />
                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                    Certificate Postal Address
                </h2>
                <InputField 
                    label="Postal Address 1"
                    name="postalAddress1"
                    register={register}
                />
                <InputField 
                    label="Postal Address 2"
                    name="postalAddress2"
                    register={register}
                />
                <InputField 
                    label="Postal City"
                    name="postalCity"
                    register={register}
                />
                <InputField 
                    label="Postal Postcode"
                    name="postalPostcode"
                    register={register}
                />
                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                    Personal Statement
                </h2>
                <TextAreaField 
                    label="Personal statement"
                    name="personalStatement"
                    register={register}
                />
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save
                </button>
            </form>
        </div>
    );
};

const WorkDetails = ({ formData, applicant, companies, appendCompany, removeCompany, setValue, handleInputChange, register, errors, control, handleSubmit, onSubmit, watch }) => {
    const [isTypeOfOrganisationOther, setTypeOfOrganisationOther] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);

    if (!countryOptions.find(c => c.countryId == 0)) {
        const newCountryOptions = [...formData.countries];
        newCountryOptions.unshift({ countryId: 0, countryDisplayName: "None" });
        setCountryOptions(newCountryOptions);
    }

    console.log(applicant.workExperience);
    const handleTypeOfOrganisationOther = (e) => {
        setTypeOfOrganisationOther(e.target.value === 'other');
    };

    const addCompany = () => {
        console.log("add company")
        appendCompany({
          companyName: '',
          companyAddress1: '',
          companyAddress2: '',
          companyCity: '',
          companyState: '',
          companyPostcode: '',
          companyCountry: '',
          jobTitle: '',
          typeOfOrganisation: '',
          typeOfOrganisationOther: '',
          startDate: '',
          workResponsibilities: ''
        });
    };

    return (
        <div className='h-full text-sm p-6 w-full'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Work details
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
            {applicant.workExperience.map((item, index) => (
                <div key={index}>
                    <div className="flex justify-between items-center">
                    <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                        Company {index + 1}
                    </h2>
                    {index > 0 && (
                        <button type="button" onClick={() => removeCompany(index)} className="text-red underline font-medium py-1 px-3 rounded">
                        Remove
                        </button>
                    )}
                    </div>
                    <InputField 
                        label="Company"
                        name={`workExperience[${index}].company`}
                        register={register}
                        rules={{ required: "Company name is required" }}
                        error={errors?.workExperience?.[index]?.company?.message}
                    />
                    <InputField 
                        label="Company Address 1"
                        name={`workExperience[${index}].companyAddress1`}
                        register={register}
                    />
                    <InputField 
                        label="Company Address 2"
                        name={`workExperience[${index}].companyAddress2`}
                        register={register}
                    />
                    <InputField 
                        label="Company City"
                        name={`workExperience[${index}].companyCity`}
                        register={register}
                    />
                    <InputField 
                        label="Company State"
                        name={`workExperience[${index}].companyState`}
                        register={register}
                    />
                    <InputField 
                        label="Company Postcode"
                        name={`workExperience[${index}].companyPostcode`}
                        register={register}
                    />
                    <SelectField
                        label="Company Country"
                        name={`workExperience[${index}].companyCountryId`}
                        register={register}
                        rules={{ required: "Company Country is required" }}
                        options={countryOptions}
                        valueField="countryId"
                        textField="countryDisplayName"
                    />
                   <RadioField 
                        label="Type of organisation"
                        name={`workExperience[${index}].typeOfOrganisationId`}
                        register={register}
                        index={index}
                        options={formData.organisationTypes.map(ot => {return { value: ot.itemId, label: ot.description, codeName: ot.codeName }})}
                        onChange={(e) => handleTypeOfOrganisationOther(e, index)}
                        rules={{ required: "The type of organisation is required" }}
                        error={errors?.workExperience?.[index]?.typeOfOrganisationId?.message}
                    />
                    {isTypeOfOrganisationOther && (
                        <InputField 
                            label="Please specify type of organisation"
                            name={`workExperience[${index}].otherTypeOfOrganisation`}
                            register={register}
                        />
                    )}
                    <CustomDatePicker
                        label="Start Date"
                        name={`workExperience[${index}].startDate`}
                        register={register}
                        selectedDate={watch(`workExperience[${index}].startDate`)}
                        setValue={setValue}
                    />
                    <TextAreaField 
                        label="In no more than 250 words, please explain what your work and responsibilities were in this role"
                        name={`workExperience[${index}].jobDescription`}
                        register={register}
                    />
                </div>
            ))}
                <button type="button" onClick={addCompany} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 mb-3 rounded-full">
                    Add More
                </button>
                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                    Experience in Insolvency and turnarounds
                </h2>
                <InputField 
                    label="Years in Insolvency and turnarounds"
                    name="industryExperienceYears"
                    register={register}
                />
                <InputField 
                    label="Experience in cross-border insolvency and turnarounds"
                    name="industryExperienceSummary"
                    register={register}
                />
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save
                </button>
            </form>
        </div>
    );
};

const Education = ({ applicant, educationHistory, appendEducation, removeEducation, qualifications, appendQualification, removeQualification, referees, appendReferee, removeReferee, formData, setFormData, setValue, register, errors, control, handleSubmit, onSubmit, watch }) => {
    const [additionalEducationFields, setAdditionalEducationFields] = useState([]);
    const [additionalQualificationFields, setAdditionalQualificationFields] = useState([]);
    const [additionalReferencesFields, setAdditionalReferencesFields] = useState([]);

    console.log(applicant.educationHistory)
    
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const newFormData = { ...formData };
        newFormData[name] = value;
        setFormData(newFormData);
    };

    const handleEducationAddMore = () => {
        setAdditionalEducationFields([...additionalEducationFields, additionalEducationFields.length]);
    };

    const handleQualificationAddMore = () => {
        setAdditionalQualificationFields([...additionalQualificationFields, additionalQualificationFields.length]);
    };

    const handleReferencesAddMore = () => {
        setAdditionalReferencesFields([...additionalReferencesFields, additionalReferencesFields.length]);
    };

    const addEducation = () => {
        appendEducation({
            collegeUniversity: '',
            description: '',
            language: '',
            yearAwarded: ''
        });
    };

    const addQualification = () => {
        appendQualification({
            qualification: '',
            dateOfAdmission: '',
            profession: '',
            practicing: false
        });
    };

    const addReferee = () => {
        appendReferee({
            refereeTitle: '',
            refereeFirstName: '',
            refereeLastName: '',
            refereeEmail: '',
            refereeCountryCode: '',
            refereePhone: '',
            refereeAddress1: '',
            refereeAddress2: '',
            refereeCity: '',
            refereeState: '',
            refereePostcode: ''
        });
    };

    return (
        <div className='text-sm p-6 w-full'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Education Qualification(s)
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                {educationHistory.map((item, index) => {
                    const applicantEducationHistory = applicant.educationHistory.find(eh => eh.courseEducationHistoryId == item.courseEducationHistoryId);
                    console.log(applicantEducationHistory)
                    return (
                    <div key={index}>
                        <div className="flex justify-between items-center">
                        <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                            Education {index + 1}
                        </h2>
                        {index > 0 && (
                            <button type="button" onClick={() => removeEducation(index)} className="text-red underline font-medium py-1 px-3 rounded">
                            Remove
                            </button>
                        )}
                        </div>
                        <InputField 
                            label="Degree"
                            name={`educationHistory[${index}].description`}
                            register={register}
                        />
                        <InputField 
                            label="Year awarded"
                            name={`educationHistory[${index}].yearAwarded`}
                            register={register}
                        />
                        <InputField 
                            label="College / University"
                            name={`educationHistory[${index}].collegeUniversity`}
                            register={register}
                        />
                        <InputField 
                            label="Language of instruction"
                            name={`educationHistory[${index}].language`}
                            register={register}
                        />
                        <UploadField 
                            label="Degree upload"
                            name={`educationHistory[${index}].file`}
                            setValue={setValue}
                            defaultFile={watch(`educationHistory[${index}]`)}
                        />
                    </div>
                )})}
                <button type="button" onClick={addEducation} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 mb-3 rounded-full">
                    Add More
                </button>
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Professional Qualification(s)
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                {qualifications.map((item, index) => (
                    <div key={index}>
                        <div className="flex justify-between items-center">
                        <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                            Qualification {index + 1}
                        </h2>
                        {index > 0 && (
                            <button type="button" onClick={() => removeQualification(index)} className="text-red underline font-medium py-1 px-3 rounded">
                            Remove
                            </button>
                        )}
                        </div>
                        <InputField 
                            label="Qualification"
                            name={`qualifications[${index}].qualificationDescription`}
                            register={register}
                        />
                        <CustomDatePicker
                            label="Date of admission"
                            name={`qualifications[${index}].qualificationDate`}
                            selectedDate={watch(`qualifications[${index}].qualificationDate`)}
                            register={register}
                            setValue={setValue}
                        />
                        <InputField 
                            label="Profession"
                            name={`qualifications[${index}].profession`}
                            register={register}
                        />
                        <RadioField 
                            label="Have you been practicing?"
                            name={`qualifications[${index}].practicing`}
                            register={register}
                            options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                ))}
                <button type="button" onClick={addQualification} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 mb-3 rounded-full">
                    Add More
                </button>
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Reference(s)
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                {applicant.references.map((item, index) => (
                    <div key={index}>
                        <div className="flex justify-between items-center">
                        <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                            Referee {index + 1}
                        </h2>
                        {index > 0 && (
                            <button type="button" onClick={() => removeReferee(index)} className="text-red underline font-medium py-1 px-3 rounded">
                            Remove
                            </button>
                        )}
                        </div>
                        <InputField
                            label="Title"
                            name={`references[${index}].title`}
                            register={register}
                        />
                        <InputField 
                            label="First name"
                            name={`references[${index}].firstName`}
                            register={register}
                        />
                        <InputField 
                            label="Last name"
                            name={`references[${index}].lastName`}
                            register={register}
                        />
                        <InputField 
                            label="Email"
                            name={`references[${index}].email`}
                            register={register}
                        />
                        <InputField 
                            label="Country code"
                            name={`references[${index}].phoneCountryCode`}
                            register={register}
                        />
                        <InputField 
                            label="Phone"
                            name={`references[${index}].phone`}
                            register={register}
                        />
                        <InputField 
                            label="Address 1"
                            name={`references[${index}].address1`}
                            register={register}
                        />
                        <InputField 
                            label="Address 2"
                            name={`references[${index}].address2`}
                            register={register}
                        />
                        <InputField 
                            label="City"
                            name={`references[${index}].city`}
                            register={register}
                        />
                        <InputField 
                            label="State"
                            name={`references[${index}].state`}
                            register={register}
                        />
                        <InputField 
                            label="Postcode"
                            name={`references[${index}].postcode`}
                            register={register}
                        />
                    </div>
                ))}
                <button type="button" onClick={addReferee} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Add More
                </button>
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save
                </button>
            </form>
        </div>
    );
};


const Modules = ({ 
    applicant,
    formData,
    selectedModules,
    selectedModuleCount,
    selectedElectiveCount,
    selectedAbCompulsoryCount,
    selectedAdditionalModules,
    setSelectedModules,
    setSelectedModuleCount,
    setSelectedElectiveCount,
    setSelectedAbCompulsoryCount,
    setSelectedAdditionalModules,
    handleInputChange,
    register, 
    errors,
    control,
    handleSubmit,
    onSubmit,
    setValue }) => {
    console.log(applicant)
    console.log(formData)

    const handleModuleSelectionChange = (e, courseModuleId, courseModuleGroupId, requirementCodeName) => {
        const { checked } = e.target;
        const moduleId = Number(courseModuleId);
      
        setSelectedModules((prevModules) => {
            let updatedModules;
        
            if (checked) {
              updatedModules = [...prevModules, { courseModuleId: moduleId, groupId: courseModuleGroupId, type: requirementCodeName }];
            } else {
              updatedModules = prevModules.filter(mod => mod.courseModuleId !== moduleId);
            }
      
            let compulsoryCount = 0;
            let electiveCount = 0;
            let abCompulsoryCount = 0;
            let totalModules = updatedModules.length;
        
            // Track "ab-compulsory" groups
            const abCompulsoryGroups = selectedModules.filter(group => group.requirementCodeName === "ab-compulsory");
      
            abCompulsoryGroups.forEach(group => {
              const selectedFromGroup = updatedModules.filter(m => m.groupId === group.courseModuleGroupId);
      
              if (selectedFromGroup.length > 0) {
                abCompulsoryCount += 1;
                selectedFromGroup.forEach((module, index) => {
                  module.type = index === 0 ? "compulsory" : "elective";
                });
              }
            });
      
            // Count total compulsory and elective modules
            updatedModules.forEach(module => {
              if (module.type === "compulsory" || module.type === "ab-compulsory") {
                compulsoryCount += 1;
              } else if (module.type === "elective") {
                electiveCount += 1;
              }
            });
      
            let additionalModules = Math.max(0, totalModules - formData.course.courseMinModules);
        
            setSelectedModuleCount(compulsoryCount + electiveCount);
            setSelectedElectiveCount(electiveCount);
            setSelectedAbCompulsoryCount(abCompulsoryCount);
            setSelectedAdditionalModules(additionalModules);
    
            // Set the updated modules while preserving validation
            setValue("modules", updatedModules, { shouldValidate: true });
    
            return updatedModules;
        });
      };

        const getModuleType = (courseModuleId, courseModuleGroupId, requirementCodeName) => {
            const isSelected = selectedModules.find(m => m.courseModuleId === courseModuleId);

            if (!isSelected) {
                return ""; // Hide type if module isn't selected
            }

            if (requirementCodeName === "ab-compulsory") {
                // If isElective is false show Compulsory, else Elective
                return isSelected.isElective ? "- Elective" : "- Compulsory";
            }

            // For all other module types, just return their default requirementCodeName
            return `- ${requirementCodeName.charAt(0).toUpperCase() + requirementCodeName.slice(1)}`;
        };
    
    return (
        <div className='text-sm p-6 w-full'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <SelectField
                    label="How many years would you like to complete the course?"
                    name="yearsToComplete"
                    register={register}
                    options={["1", "2"]}
                />
                {formData.course.moduleGroups.map((moduleGroup, index) => {
                //const groupError = validateModules().find(err => err.groupId === moduleGroup.courseModuleGroupId);
                return (
                <div key={"module-" + index}>
                    <div className="flex items-center mb-6">
                    {(moduleGroup.requirementCodeName === "compulsory" || moduleGroup.requirementCodeName === "ab-compulsory") && (
                        <span className="font-bold text-red mr-2">*</span>
                    )}
                    <label className='text-brandMidBlue block text-sm font-bold'>
                        {moduleGroup.groupName}
                    </label>
                    </div>
                    
                    {/*groupError && <p className="text-red text-xs mb-6">{groupError.message}</p>*/}
                    
                    {moduleGroup.modules.map((module, index) => {
                    const isCompulsory = moduleGroup.requirementCodeName === "compulsory";

                    return (
                        <CheckboxField
                            key={module.courseModuleId}
                            label={`${module.moduleName} ${getModuleType(module.courseModuleId, module.courseModuleGroupId, moduleGroup.requirementCodeName)}`}
                            name={`modules[${moduleGroup.courseModuleGroupId}][${index}]`}
                            fontWeight="normal"
                            disabled={isCompulsory}
                            checked={selectedModules.some(m => m.courseModuleId === module.courseModuleId)}     
                            value={module.courseModuleId}
                            error={errors.modules?.message}
                            onChange={(e) => !isCompulsory && handleModuleSelectionChange(e, module.courseModuleId, module.courseModuleGroupId, moduleGroup.requirementCodeName)}
                        />
                    )
                    })}
                </div>
                )
            })}
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save
                </button>
            </form>
        </div>
    );
}

const EntryCriteria = ({ applicant, formData, handleInputChange, register, errors, control, setValue, handleEntryCriteriaChange, checkedEntryCriteria, getErrorMessage, handleSubmit, onSubmit }) => {
    return (
    <div className='h-full text-sm p-6 w-full'>
        <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
            Entry Criteria
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
        </h2>
        <form onSubmit={handleSubmit(onSubmit)}>
            {formData.course.entryCriteria.map((item, index) => {
                const applicantEntryCriteria = applicant.entryCriteria.find(ec => ec.courseEntryCriteriaId == item.courseEntryCriteriaId);
                return (
                <div key={index}>
                    <div className="flex justify-between items-center">
                    <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                        Entry Criteria {index + 1}
                    </h2>
                    </div>
                    <div data-id={item.courseEntryCriteriaId} key={item.courseEntryCriteriaId}>
                        {!item.isDouble ? (
                        <>
                            <CheckboxField
                            name={`entryCriteria[${index}].selection`}
                            labelLeft={item.statement}
                            explanation={item.clarification}
                            register={register}
                            value={1}
                            rules={{ required: "Entry criteria is required" }}
                            error={getErrorMessage("entryCriteria", index, "selection")}
                            onChange={(e) => handleEntryCriteriaChange(e, index)}
                            />
                            {checkedEntryCriteria[index] === "1" && item.fileUploadRequired && (
                            <UploadField 
                                label="Upload"
                                name={`entryCriteria[${index}].file`}
                                setValue={setValue}
                                defaultFile={applicantEntryCriteria}
                            />
                            )}
                        </>
                        ) : (
                        <>
                            <RadioField 
                            label="Please select which entry criteria you meet"
                            name={`entryCriteria[${index}].selection`}
                            register={register}
                            options={[
                                { value: 1, label: item.statement, explanation: item.clarification },
                                { value: 2, label: item.statement2, explanation: item.clarification2 }
                            ]}
                            rules={{ required: "Entry criteria is required" }}
                            error={getErrorMessage("entryCriteria", index, "selection")}
                            onChange={(e) => handleEntryCriteriaChange(e, index)}
                            />
                            {checkedEntryCriteria[index] === "1" && item.fileUploadRequired && (
                            <UploadField 
                                name={`entryCriteria[${index}].file`}
                                setValue={setValue}
                                defaultFile={applicantEntryCriteria}
                            />
                            )}
                        </>
                        )}
                        
                    </div>
                </div>
            )})}
            <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
            <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                Save
            </button>
        </form>
    </div>
);
};

const Invoices = ({ applicant, formData, register, errors, control, paymentPreview, setShowPaymentPreviewModal, showPaymentPreviewModal, handleSubmit, handleContinuePayment, onSubmit, watch, sendInvoice }) => {
    const appContext = useContext(AppContext);
    const [pricePreview, setPricePreview] = useState(null); // Holds price details
    const [isSubmittingInvoice, setIsSubmittingInvoice] = useState(false); // To track if the invoice is being sent

    const fetchPricePreview = async (data) => {
        try {
            if (data.qualifications.length) {
                data.qualifications.forEach(q => {
                    if (q.practicing === "true" || q.practicing === true) {
                        q.practicing = true;
                    } else {
                        q.practicing = false;
                    }
                });
            }
            const response = await appContext.httpClient.post({
                path: "courseapplication/paymentinfo",
                body: data,
            });
            if (response.success && response.result) {
                setPricePreview(response.result); // Show price details in the modal
                setShowPaymentPreviewModal(true);
            } else {
                console.error("Error fetching payment preview:", response.message || "Unknown error.");
            }
        } catch (error) {
            console.error("Error fetching payment preview:", error);
        }
    };

    const handleUpdateInvoiceClick = async () => {
        const invoiceData = watch(); // Get current form data
        await fetchPricePreview(invoiceData); // Show modal with price preview
    };

    const handleClosePaymentPreviewModal = () => {
        setShowPaymentPreviewModal(false);
    };

    const confirmAndUpdateInvoice = async () => {
        setIsSubmittingInvoice(true);
        try {
            const invoiceData = watch(); // Get current form data
            const response = await appContext.httpClient.post({
                path: "courseapplication/invoice",
                body: invoiceData,
            });
            if (response.success) {
                window.location.reload();
            }
        } catch (error) {
            console.error("Error sending invoice:", error);
        } finally {
            setIsSubmittingInvoice(false);
        }
    };

    const confirmAndSendInvoice = async () => {
        setIsSubmittingInvoice(true);
        try {
            const invoiceData = watch(); // Get current form data
            const response = await appContext.httpClient.post({
                path: "courseapplication/sendinvoice",
                body: invoiceData,
            });
            window.location.reload();
        } catch (error) {
            console.error("Error sending invoice:", error);
        } finally {
            setIsSubmittingInvoice(false);
        }
    };

    return (
        <>
            <div className='h-full text-sm p-6 w-full'>
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Invoices
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                <p className='text-uidarker pr-6 text-md relative flex mb-6'>
                    To view this application's invoice please go to the E-commerce > Orders module. 
                </p>
                {formData.invoice && (
                    <div 
                        dangerouslySetInnerHTML={{
                            __html: formData.invoice.replace(/RECEIPT/g, "INVOICE").replace(/TAX:/g, "VAT:"),
                        }}
                        className="invoice-content"
                    />
                )}
                {applicant?.latestInvoiceSent && (
                    <div className="inline-flex py-2 px-4 mb-6" style={{ backgroundColor: 'lightgreen' }}>
                        <span>This invoice has been sent to the applicant.</span>
                    </div>
                )}
                <div class="flex gap-4">
                    <button type="button" onClick={handleUpdateInvoiceClick} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                        Update invoice
                    </button>
                    <button type="button" onClick={confirmAndSendInvoice} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                        Send invoice
                    </button>
                </div>
                {/*formData.latestInvoiceSent ? (
                    <p className='text-uidarker pr-6 text-md relative flex mt-4'>
                        The latest invoice was sent on {new Date(formData.latestInvoiceSent).toLocaleDateString()}.
                    </p>
                ) : (
                     <p className='text-uidarker pr-6 text-md relative flex mt-4'>
                        The latest invoice was sent on {new Date(formData.latestInvoiceSent).toLocaleDateString()}.
                    </p>
                )*/}
            </div>
            {pricePreview && (
                <Modal
                    isOpen={showPaymentPreviewModal}
                    onClose={handleClosePaymentPreviewModal}
                    className="max-w-md"
                >
                    <div className="p-6">
                        <h2 className="text-lg font-bold mb-4">Application  Price</h2>
                        <p className="mb-4">If the price is incorrect please go back and amend the discounts and try again.</p>
                        <p className="mb-4">If the price is correct and you would like to update the invoice, please click Update.</p>
                        <table className="table-auto w-full mb-4">
                            <thead>
                                <tr>
                                    <td className="py-2 text-left">Course</td>
                                    <td className="py-2 text-left">£{pricePreview.price}</td>
                                </tr>
                                {pricePreview.discount > 0 && (
                                    <tr>
                                        <td className="py-2 text-left">Discount</td>
                                        <td className="py-2 text-left">-£{pricePreview.discount}</td>
                                    </tr>
                                )}
                                {pricePreview?.tax > 0 && (
                                    <tr>
                                        <td className="py-2 text-left">VAT</td>
                                        <td className="py-2 text-left">£{pricePreview.tax}</td>
                                    </tr>
                                )}
                                <tr className="border-t">
                                    <td className="py-2 text-left">Total</td>
                                    <td className="py-2 text-left">£{pricePreview.totalAmountDue}</td>
                                </tr>
                            </thead>
                        </table>
                        <div className="flex justify-end mt-4">
                            <button
                                onClick={handleClosePaymentPreviewModal}
                                className="bg-uidark hover:bg-blue-700 text-uidarker font-medium py-2 px-6 mr-3 rounded-full"
                            >
                                Go back
                            </button>
                            <button
                                onClick={confirmAndUpdateInvoice}
                                className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
          </>
    );
};

const Status = ({ applicant, formData, register, errors, control, handleSubmit, onSubmit, setValue, watch }) => {
    const [isBursaryDiscountChecked, setBursaryDiscountChecked] = useState(false);

    console.log(applicant.discountCode)

    useEffect(() => {
        if (applicant.discountCode) {
            setBursaryDiscountChecked(true);
        }
    }, [applicant.discountCode]);

    const handleBursaryDiscount = (e) => {
        setBursaryDiscountChecked(e.target.checked);
        console.log(isBursaryDiscountChecked)
    };

    const handleStatusChange = (e) => {
        const selectedStatus = e.target.value;
    };
    
    return (
        <div className='h-full text-sm p-6 w-full'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Billing details
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                <InputField 
                    label="Company Name/Billing Name"
                    name="billingName"
                    register={register}
                />
                <InputField 
                    label="Billing Address 1"
                    name="billingAddress1"
                    register={register}
                />
                <InputField 
                    label="Billing Address 2"
                    name="billingAddress2"
                    register={register}
                />
                <InputField 
                    label="Billing City"
                    name="billingCity"
                    register={register}
                />
                <InputField 
                    label="Billing State"
                    name="billingState"
                    register={register}
                />
                <InputField 
                    label="Billing Postcode"
                    name="billingPostcode"
                    register={register}
                />
                <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                    Payment &amp; Status
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                </h2>
                {formData.course.courseQuestionDiscountContent && (
                    <CheckboxField
                        labelLeft={formData.course.courseQuestionDiscountContent}
                        name="applyQuestionDiscount"
                        type="checkbox"
                        register={register}
                    />
                )}
                <CheckboxField
                    labelLeft="Apply bursary discount"
                    name="applyBursaryDiscount"
                    type="checkbox"
                    register={register}
                    onChange={event => {
                        setValue("applyBursaryDiscount", event.target.checked);
                    }}
                />
                {watch('applyBursaryDiscount') && (
                    <InputField 
                        label="Enter discount code here"
                        name="discountCode"
                        register={register}
                    />
                )}
                <SelectField
                    label="Payment Method"
                    name="paymentMethod"
                    options={["CARD", "BACS"]}
                    register={register}
                />
                <SelectField
                    label="Status"
                    name="statusId"
                    options={formData.statuses}
                    valueField="itemId"
                    textField="description"
                    onChange={handleStatusChange}
                    register={register}
                />
                <TextAreaField 
                    label="Email message"
                    name="emailMessage"
                    register={register}
                />
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save
                </button>
            </form>
        </div>
    );
};

const Export = ({ applicant, formData, register, errors, control, handleSubmit, onSubmit }) => {

    const pdfExportComponent = useRef(null);

    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };

    const gender = formData.genders.find(g => g.itemId === applicant.genderId)?.description;
    const nationality = formData.countries.find(c => c.countryId === applicant.nationalityId)?.countryDisplayName;
    const residence = formData.countries.find(c => c.countryId === applicant.countryOfResidenceId)?.countryDisplayName;
    
    return (
        <div className='h-full text-sm p-6 w-full'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Export
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
                <button type="button" onClick={exportPDFWithComponent} className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Export application
                </button>
                <PDFExport ref={pdfExportComponent} paperSize="A4" scale={1}>
                    <div className="p-8">
                        <h2 className="text-md text-brandDarkBlue font-bold my-6">Personal Details</h2>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Title</label>
                            <div className='font-normal'>
                                {applicant.title}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>First name</label>
                            <div className='font-normal'>
                                {applicant.firstName}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Middle name</label>
                            <div className='font-normal'>
                                {applicant.middleName}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Last name</label>
                            <div className='font-normal'>
                                {applicant.lastName}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Certificate name</label>
                            <div className='font-normal'>
                                {applicant.certificateName}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Email</label>
                            <div className='font-normal'>
                                {applicant.email}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Email to receive course notifications</label>
                            <div className='font-normal'>
                                {applicant.courseCorrespondenceEmail}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Phone</label>
                            <div className='font-normal'>
                                {applicant.phone}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Mobile</label>
                            <div className='font-normal'>
                                {applicant.mobile}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Gender</label>
                            <div className='font-normal'>
                                {gender}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Nationality</label>
                            <div className='font-normal'>
                                {nationality}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Country of residence</label>
                            <div className='font-normal'>
                                {residence}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Home Address 1</label>
                            <div className='font-normal'>
                                {applicant.homeAddress1}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Home Address 2</label>
                            <div className='font-normal'>
                                {applicant.homeAddress2}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>City</label>
                            <div className='font-normal'>
                                {applicant.homeCity}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>State</label>
                            <div>
                                {applicant.homeState}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Postcode</label>
                            <div className='font-normal'>
                                {applicant.homePostcode}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Postal Address 1</label>
                            <div className='font-normal'>
                                {applicant.postalAddress1}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Postal Address 2</label>
                            <div className='font-normal'>
                                {applicant.postalAddress2}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Postal City</label>
                            <div className='font-normal'>
                                {applicant.postalCity}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Postal Postcode</label>
                            <div className='font-normal'>
                                {applicant.postalPostcode}
                            </div>
                        </div>
                        <div className='mb-3 flex w-full text-xs'>
                            <label className='text-uidarker font-bold pr-6 text-right'>Personal Statement</label>
                            <div className='font-normal'>
                                {applicant.personalStatement}
                            </div>
                        </div>
                        <h2 className="text-md text-brandDarkBlue font-bold my-6">Work Experience</h2>
                        {applicant.workExperience.map((company, index) => {
                            const companyCountry = formData.countries.find(c => c.countryId === company.companyCountryId)?.countryDisplayName;
                            const companyType = formData.organisationTypes.find(o => o.itemId === Number(company.typeOfOrganisationId))?.description;
                            const formatDate = (dateString) => {
                                return new Date(dateString).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                });
                            };
                            return (
                                <>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company</label>
                                        <div className='font-normal'>
                                            {company.company}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company Address 1</label>
                                        <div className='font-normal'>
                                            {company.companyAddress1}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company Address 2</label>
                                        <div className='font-normal'>
                                            {company.companyAddress2}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company City</label>
                                        <div className='font-normal'>
                                            {company.companyCity}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company State</label>
                                        <div className='font-normal'>
                                            {company.companyState}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company Postcode</label>
                                        <div className='font-normal'>
                                            {company.companyPostcode}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Company Country</label>
                                        <div className='font-normal'>
                                            {companyCountry}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Job title</label>
                                        <div className='font-normal'>
                                            {company.jobTitle}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Type of organisation</label>
                                        <div className='font-normal'>
                                            {companyType}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Other type of organisation</label>
                                        <div className='font-normal'>
                                            {company.otherTypeOfOrganisation}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Start Date</label>
                                        <div className='font-normal'>
                                            {formatDate(company.startDate)}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Job Description</label>
                                        <div className='font-normal'>
                                            {company.jobDescription}
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                        <h2 className="text-md text-brandDarkBlue font-bold my-6">Education Qualifications</h2>
                        {applicant.educationHistory.map((education, index) => (
                            <>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Degree</label>
                                    <div className='font-normal'>
                                        {education.description}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Year awarded</label>
                                    <div className='font-normal'>
                                        {education.yearAwarded}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>College / University</label>
                                    <div className='font-normal'>
                                        {education.collegeUniversity}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Language of instruction</label>
                                    <div className='font-normal'>
                                        {education.language}
                                    </div>
                                </div>
                            </>
                        ))}
                        {applicant.qualifications.map((qualification, index) => {
                            const formatDate = (dateString) => {
                                return new Date(dateString).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                });
                            };                        
                            return (
                                <>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Qualification</label>
                                        <div className='font-normal'>
                                            {qualification.qualificationDescription}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Date of admission</label>
                                        <div className='font-normal'>
                                            {formatDate(qualification.qualificationDate)}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Profession</label>
                                        <div className='font-normal'>
                                            {qualification.profession}
                                        </div>
                                    </div>
                                    <div className='mb-3 flex w-full text-xs'>
                                        <label className='text-uidarker font-bold pr-6 text-right'>Practicing</label>
                                        <div className='font-normal'>
                                            {qualification.practicing}
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                        {applicant.educationHistory.map((education, index) => (
                            <>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Degree</label>
                                    <div className='font-normal'>
                                        {education.description}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Year awarded</label>
                                    <div className='font-normal'>
                                        {education.yearAwarded}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>College / University</label>
                                    <div className='font-normal'>
                                        {education.collegeUniversity}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Language of instruction</label>
                                    <div className='font-normal'>
                                        {education.language}
                                    </div>
                                </div>
                            </>
                        ))}
                        <h2 className="text-md text-brandDarkBlue font-bold my-6">References</h2>
                        {applicant.references.map((reference, index) => (
                            <>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Title</label>
                                    <div className='font-normal'>
                                        {reference.title}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>First name</label>
                                    <div className='font-normal'>
                                        {reference.firstName}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Last name</label>
                                    <div className='font-normal'>
                                        {reference.lastName}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Email</label>
                                    <div className='font-normal'>
                                        {reference.email}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Country code</label>
                                    <div className='font-normal'>
                                        {reference.phoneCountryCode}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Phone</label>
                                    <div className='font-normal'>
                                        {reference.phone}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Address 1</label>
                                    <div className='font-normal'>
                                        {reference.address1}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Address 2</label>
                                    <div className='font-normal'>
                                        {reference.address2}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>City</label>
                                    <div className='font-normal'>
                                        {reference.city}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>State</label>
                                    <div className='font-normal'>
                                        {reference.state}
                                    </div>
                                </div>
                                <div className='mb-3 flex w-full text-xs'>
                                    <label className='text-uidarker font-bold pr-6 text-right'>Postcode</label>
                                    <div className='font-normal'>
                                        {reference.postcode}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </PDFExport>
        </div>
    );
};

const EditApplication = () => {
    const { applicationId, section } = useParams();
    const [applicant, setApplicant] = useState(null);
    //const [activeSection, setActiveSection] = useState('personal');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [isInitRequested, setIsInitRequested] = useState(false);
    const [areAllModulesRequired, setAreAllModulesRequired] = useState(true);
    
    const [showPaymentPreviewModal, setShowPaymentPreviewModal] = useState(false);
    const [paymentPreview, setPaymentPreview] = useState(false);
    const [confirmPaymentPreview, setConfirmPaymentPreview] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showFormErrorModal, setShowFormErrorModal] = useState(false);
    const [formError, setFormError] = useState(false);

    const [selectedModules, setSelectedModules] = useState([]);
    const [selectedModuleCount, setSelectedModuleCount] = useState(0);
    const [selectedElectiveCount, setSelectedElectiveCount] = useState(0);
    const [selectedAbCompulsoryCount, setSelectedAbCompulsoryCount] = useState(0);
    const [selectedAdditionalModules, setSelectedAdditionalModules] = useState(0);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialSection = queryParams.get('section') || 'personal';
    const [activeSection, setActiveSection] = useState(initialSection);


    const appContext = useContext(AppContext);
    const [formData, setFormData] = useState(null);

    const { register, handleSubmit, reset, control, setValue, watch, formState: { errors } } = useForm({
        defaultValues: {
            companies: [],
            modules: selectedModules.map(m => m.courseModuleId),
        }
    });
    

    useEffect(() => {

        if (!isInitRequested) {
            appContext.httpClient.get({
                path: "courseapplication/" + applicationId,
                authRedirectPath: appContext.loginPath
            }).then(response => {
                console.log(response.result);
                if (response.result) {  
                    console.log(response.result);
                    if (!response.result.workExperience) response.result.workExperience = [];
                    if (!response.result.educationHistory) response.result.educationHistory = [];
                    if (!response.result.qualifications) response.result.qualifications = [];
                    if (!response.result.references) response.result.references = [];
                    setApplicant(response.result);
                    setSelectedModules(response.result.modules);

                    response.result.workExperience.forEach(we => {
                        if (we.typeOfOrganisationId) 
                            we.typeOfOrganisationId = we.typeOfOrganisationId.toString();
                    });

                    response.result.qualifications.forEach(qu => {
                        if (qu.practicing) 
                            qu.practicing = qu.practicing.toString().toLowerCase();
                    });

                    if (response.result.entryCriteria) {
                        response.result.entryCriteria.forEach(ec => {
                            if (ec.selection) 
                                ec.selection = ec.selection.toString();
                        });
                        
                        const checkedEntryCriteriaLocal = {};
                        setCheckedEntryCriteria(response.result.entryCriteria.map((ec, index) => {
                            checkedEntryCriteriaLocal[index] = ec.selection;
                        }));
                        setCheckedEntryCriteria(checkedEntryCriteriaLocal);
                    }

                    reset(response.result);
                }
            });

            setIsInitRequested(true);
              appContext.httpClient.get({
                  path: "courseapplication/adminformdata/" + applicationId,
                  authRedirectPath: appContext.loginPath
              }).then(response => {
                  console.log(response.result)
                  if (response.result) {     
                    console.log(response.result);
                    setAreAllModulesRequired(response.result.course.allModulesRequired);
                    setFormData(response.result);
                  }
              });
        }

    }, [appContext.apiBaseUrl, reset]);

    const {
        fields: companies,
        append: appendCompany,
        remove: removeCompany
    } = useFieldArray({
        control,
        name: 'companies'
    });

    const {
        fields: educationHistory,
        append: appendEducation,
        remove: removeEducation
    } = useFieldArray({
        control,
        name: 'educationHistory'
    });

    const {
        fields: qualifications,
        append: appendQualification,
        remove: removeQualification
    } = useFieldArray({
        control,
        name: 'qualifications'
    });

    const {
        fields: referees,
        append: appendReferee,
        remove: removeReferee
    } = useFieldArray({
        control,
        name: 'referees'
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const [checkedEntryCriteria, setCheckedEntryCriteria] = useState({});

    const handleEntryCriteriaChange = (e, index) => {
        const { name, value, checked } = e.target;

        setCheckedEntryCriteria((prevState) => ({
        ...prevState,
        [index]: checked
        }));

        console.log(`Changed field at index ${index}:`, { name, value, checked });
    };

    const getErrorMessage = (list, index, field) => {
        return errors[list] &&
        errors[list].length > index &&
        errors[list][index] &&
        errors[list][index][field] &&
        errors[list][index][field].message;
    }

    const onSubmit = async (data) => {
        console.log("test")
        if (data.qualifications.length) {
            console.log("Before fix:", data.qualifications);
            data.qualifications.forEach(q => {
                if (q.practicing === "true" || q.practicing === true) {
                    q.practicing = true;
                } else {
                    q.practicing = false;
                }
            });
            console.log("After fix:", data.qualifications);  
        }

        const revisedData = {
            ...data,
            modules: selectedModules
        }

        const response = await appContext.httpClient.post({
            path: "courseapplication",
            body: revisedData
        });

        if (response.success) {
            setShowSuccessModal(true);
        }
        else {  
            // Handle server-side validation or processing errors
            console.log("Error submitting the form:", response.message || "Unknown error occurred.");
            debugger;
          }
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
    };

    const handleContinueEditing = () => {
        window.location.reload();
    };

    if (!applicant || !formData) {
        return <div>Loading...</div>;
    }

    // Render the edit form with the applicant data
    return (
        <div className="flex h-full">
            <Sidebar applicationId={applicationId} setActiveSection={setActiveSection} activeSection={activeSection} areAllModulesRequired={areAllModulesRequired} />
            <div className="flex-1 overflow-y-auto">
                <h2 className='text-uidarker px-6 pt-6 text-md relative flex items-center'>
                    Applications
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                    {applicant.firstName} {applicant.lastName} - ({applicant.studentId})
                </h2>
                {activeSection === 'personal' && applicant && (
                    <PersonalDetails 
                        formData={formData}
                        applicant={applicant}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange}
                    />
                )}
                {activeSection === 'work' && (
                    <WorkDetails
                        formData={formData}
                        applicant={applicant}
                        companies={companies}
                        appendCompany={appendCompany}
                        removeCompany={removeCompany}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange}
                        setValue={setValue}
                        watch={watch}
                    />
                )}
                {activeSection === 'education' && (
                    <Education 
                        applicant={applicant}
                        educationHistory={educationHistory}
                        appendEducation={appendEducation}
                        removeEducation={removeEducation}
                        qualifications={qualifications}
                        appendQualification={appendQualification}
                        removeQualification={removeQualification}
                        referees={referees}
                        appendReferee={appendReferee}
                        removeReferee={removeReferee}
                        formData={formData}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange}
                        setValue={setValue}
                        watch={watch}
                    />
                )}
                {activeSection === 'entry-criteria' && (
                    <EntryCriteria 
                        applicant={applicant}
                        formData={formData}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange} handleEntryCriteriaChange={handleEntryCriteriaChange} checkedEntryCriteria={checkedEntryCriteria}
                        getErrorMessage={getErrorMessage}
                    />
                )}
                {activeSection === 'modules' && !areAllModulesRequired && (
                    <Modules 
                        applicant={applicant}
                        formData={formData}
                        selectedModules={selectedModules}
                        selectedModuleCount={selectedModuleCount}
                        selectedElectiveCount={selectedElectiveCount}
                        selectedAbCompulsoryCount={selectedAbCompulsoryCount}
                        selectedAdditionalModules={selectedAdditionalModules}
                        setSelectedModules={setSelectedModules}
                        setSelectedModuleCount={setSelectedModuleCount}
                        setSelectedElectiveCount={setSelectedElectiveCount}
                        setSelectedAbCompulsoryCount={setSelectedAbCompulsoryCount}
                        setSelectedAdditionalModules={setSelectedAdditionalModules}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit} 
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange}
                        setValue={setValue}
                    />
                )}
                {activeSection === 'invoices' && (
                    <Invoices 
                        applicant={applicant}
                        formData={formData}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={onSubmit}
                        handleInputChange={handleInputChange}
                        //handleClosePaymentPreviewModal={handleClosePaymentPreviewModal}
                        //handleContinuePayment={handleContinuePayment}
                        paymentPreview={paymentPreview}
                        setShowPaymentPreviewModal={setShowPaymentPreviewModal}
                        showPaymentPreviewModal={showPaymentPreviewModal}
                        //sendInvoice={sendInvoice}
                        //setIsSubmitting={setIsSubmitting}
                        watch={watch}
                    />
                )}
                {activeSection === 'status' && (
                    <Status applicant={applicant} formData={formData} register={register} control={control} errors={errors} handleSubmit={handleSubmit} onSubmit={onSubmit} handleInputChange={handleInputChange} setValue={setValue} watch={watch} />
                )}
                {activeSection === 'export' && (
                    <Export applicant={applicant} formData={formData} register={register} control={control} errors={errors} handleSubmit={handleSubmit} onSubmit={onSubmit} handleInputChange={handleInputChange} />
                )}
                <Modal
                    isOpen={showSuccessModal}
                    onClose={handleCloseSuccessModal}
                    className="max-w-xl"
                >
                    <div className="p-6">
                        <h2 className="text-lg font-bold mb-4">Success</h2>
                        <p>The application has been successfully saved.</p>
                        <div className="flex justify-end mt-4">
                            <Link to="/education-admin/applications">
                                <button
                                    className="bg-ui font-medium py-2 px-6 mr-3 rounded-full"
                                >
                                    Back to applications
                                </button>
                            </Link>
                            <button
                                onClick={handleContinueEditing}
                                className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full"
                            >
                                Continue editing
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default EditApplication;